export const mobileMenu = function (el) {
    const menuEnabler = el.querySelector(".enable-menu");
    menuEnabler.addEventListener("click", function () {
        el.classList.add("menu-enabled");
    });
    const menuDisabler = el.querySelector(".disable-menu");
    menuDisabler.addEventListener("click", function () {
        el.classList.remove("menu-enabled");
    });
};
